import {
  teamsAccessService
} from "../services/api";
import type {
  TeamsConversation
} from "../services/api";
import {
  PersonalReadAccessModal
} from "./PersonalReadAccessModal";
import type {
  PersonalReadAccessConfig
} from "./PersonalReadAccessModal";

interface TeamsAccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDisconnect: () => Promise<void>;
  /** Fired after the list is saved so the tile's detail can refresh. */
  onSaved: () => Promise<void>;
}

const TEAMS_CONFIG: PersonalReadAccessConfig<TeamsConversation> = {
  title: "Microsoft Teams — what your assistant can read",
  intro:
    "Your assistant reads these through your Microsoft Teams connection, read-only. It can "
    + "never post, react, or mark anything as read. Tick what it may read.",
  radioName: "teams-access-mode",
  searchPlaceholder: "Find a channel or person",
  kindOrder: { channel: 0, chat: 1, group_chat: 2, meeting_chat: 3 },
  kindLabel: {
    channel: "Channel",
    chat: "Chat",
    group_chat: "Group chat",
    meeting_chat: "Meeting chat",
  },
  displayName: (c) => c.name,
  incompleteNote:
    "You're in more chats or teams than we could list. Ones missing here can't be ticked yet; "
    + "ask your assistant to request access to one by name.",
  loadError: "Couldn't load your Teams conversations.",
  listConversations: () => teamsAccessService.listConversations(),
  saveAccess: (mode, ids, listedIds) =>
    teamsAccessService.updateAccess({ access_mode: mode, conversation_ids: ids, listed_ids: listedIds }),
};

/**
 * Which of the owner's Teams chats and channels the assistant may read
 * through their (read-only) Microsoft Teams connection — GET-14326.
 */
export function TeamsAccessModal(props: TeamsAccessModalProps) {
  return <PersonalReadAccessModal {...props} config={TEAMS_CONFIG} />;
}
